module.exports = __webpack_public_path__ + "media/hero.26204027.webm";